import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { ConfigType } from 'src/domains/layouts/config/features/types';

type GeniusWidgetConfigType = NonNullable<ConfigType['geniusScoreboard']>;

export type GeniusWidgetKindType = 'gameTracker' | 'scoreboard';

export type GeniusWidgetConfigResultType = {
    kind: GeniusWidgetKindType;
    geniusScoreboard: GeniusWidgetConfigType;
    fixtureId: string;
};

const sportInList = (sports: ConfigType['scoreboard']['geniusGameTracker'], sport: string): boolean => {
    return sports !== null && sports.some((item) => item === sport);
};

export const getGeniusWidgetConfig = (
    event: EventModel,
    config: Pick<ConfigType, 'scoreboard' | 'geniusScoreboard' | 'geniusScoreboardsEnabled'>
): GeniusWidgetConfigResultType | null => {
    const { scoreboard, geniusScoreboard, geniusScoreboardsEnabled } = config;

    if (geniusScoreboardsEnabled !== true || geniusScoreboard === null) {
        return null;
    }

    const fixtureId = event.feedExternalId;

    if (fixtureId === null) {
        return null;
    }

    const isGameTracker = sportInList(scoreboard.geniusGameTracker, event.sport);
    const isScoreboard = sportInList(scoreboard.geniusScoreboard, event.sport);

    if (isGameTracker === false && isScoreboard === false) {
        return null;
    }

    // Prefer gameTracker when a sport is accidentally listed in both
    const kind: GeniusWidgetKindType = isGameTracker ? 'gameTracker' : 'scoreboard';

    return { kind, geniusScoreboard, fixtureId };
};
